import { Badge } from "@marekl/adminer/components";
import type { MembershipRole } from "../../lib/queries/memberships";
import { ROLE_LABELS } from "../../pages/team/TeamDetailPage/memberFormSchema";
import styles from "./RoleBadge.module.css";

/** A role on a soupiska: the three membership roles, plus leadership. */
export type RoleBadgeRole = MembershipRole | "leader";

const CLASS: Record<RoleBadgeRole, string> = {
  leader: styles.leader,
  coach: styles.coach,
  assistant: styles.assistant,
  athlete: styles.athlete,
};

/**
 * A role, one colour per role (`--cmf-role-*` in tokens.css). Like AgeBadge,
 * this is the only thing that turns a role into pixels.
 */
export function RoleBadge({ role }: { role: RoleBadgeRole }) {
  return (
    <Badge variant="muted" className={`${styles.slot} ${CLASS[role]}`}>
      {role === "leader" ? "Vedoucí" : ROLE_LABELS[role]}
    </Badge>
  );
}
